import React from "react"
import { Button, Modal } from "react-bootstrap";
import { MdClose, MdVisibility } from 'react-icons/md';
import { HeaderModal, Info, TitleModal, Description, BoxCloseModal } from './styles';
import { getFluxoProps, getFormsProps } from "../../@types/information";

interface Props {
  isActive: boolean;
  handleActive: () => void;
  data: getFluxoProps | getFormsProps;
}

const InformationModal = ({
  isActive,
  handleActive,
  data
}: Props) => {

  return (
    <Modal size='lg' show={isActive} onHide={handleActive}>
      <HeaderModal>
        <Info>
          <MdVisibility size={22} />
          <TitleModal>{data.titulo}</TitleModal>
        </Info>
        <BoxCloseModal onClick={handleActive}>
          <MdClose size={22} />
        </BoxCloseModal>
      </HeaderModal>
      <Modal.Body>
        <Description dangerouslySetInnerHTML={{ __html: data.descricao }}></Description>
      </Modal.Body>
      <Modal.Footer className="justify-content-start">
        <Button
          variant="danger"
          onClick={handleActive}
        >
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>

  );
}

export default InformationModal;